import moment, { Moment } from 'moment-timezone'

export const convertUTCTimezone = (timezone: string, date?: string): Moment => {
  const isUTCTimezone = timezone.includes('UTC')
  const utcOffset = timezone.slice(3)
  return isUTCTimezone
    ? moment.utc(date).utcOffset(parseInt(utcOffset))
    : moment.tz(date, timezone)
}

export const convertUTCRecurringLabel = (
  byDay: string,
  inputFormat: string,
  timezone: string,
): Moment => {
  const isUTCTimezone = timezone.includes('UTC')
  return isUTCTimezone
    ? moment.utc(byDay, inputFormat, timezone)
    : moment.tz(byDay, inputFormat, timezone)
}

export const startOfMonth = (date: Moment): Moment => {
  return date.clone().startOf('month')
}

export const validDateOr = <T>(date: Moment, fallback: T): Moment | T =>
  date.isValid() ? date : fallback

export const extendDay = (): number => {
  return (moment().day() + 6) % 7
}

export const extendWeekdays = (byWeekDay?: number): string => {
  return moment.weekdays(((byWeekDay || 0) + 1) % 7)
}

export const extendWeekdaysShort = (): Array<{
  weekday: string
  index: number
}> => {
  return moment.weekdaysShort().map((wd, i) => ({
    weekday: wd,
    index: (i + 6) % 7,
  }))
}
